import { render, staticRenderFns } from "./ClientYearReport.vue?vue&type=template&id=664ce448&scoped=true"
import script from "./ClientYearReport.vue?vue&type=script&lang=js"
export * from "./ClientYearReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664ce448",
  null
  
)

export default component.exports